import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import axios from "axios";
import styled from "styled-components";
import GlobalStyle from './GlobalStyle';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { FaEye } from "react-icons/fa";

const Content = styled.div`
  width: 100%;
  max-width: 1200px;
  padding: 5px;
  box-sizing: border-box;
`;

const PageContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 0;
  margin: 0;
  box-sizing: border-box;
`;

const TableWrapper = styled.div`
 width: 100%;
 overflow-x: auto;
`;

const TopButtons = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
  flex-wrap: wrap;
`;

const FiltersContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 20px;
`;

const Input = styled.input`
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #ccc;
  flex: 1;
  min-width: 200px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: #fdfdfd;
  table-layout: fixed;
`;

const Th = styled.th`
  background-color: #f1f3f5;
  padding: 10px;
  border: 1px solid #ddd;
  text-align: left;
  white-space: nowrap;
`;

const Td = styled.td`
  padding: 10px;
  border: 1px solid #ddd;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const TdStyled = styled.td`
  border: 1px solid #ccc;
  padding: 8px;
  font-size: 14px;
  text-align: center;
  position: relative;
  max-width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

.tooltip-custom {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: #333;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 10;
  margin-top: 4px;
}
`;

const Pagination = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
  gap: 10px;
`;

const Button = styled.button`
  padding: 10px 20px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;

  &:hover {
    background: #0056b3;
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
`;

const DriverColorDot = styled.span`
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: ${(props) => props.color || '#ccc'};
  margin-right: 8px;
  vertical-align: middle;
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ModalContent = styled.div`
  background: white;
  padding: 20px;
  max-width: 500px;
  max-height: 70vh;
  overflow-y: auto;
  border-radius: 8px;
`;


const CreateOrder = () => {
const calculateTotal = () => {
  return selectedProducts.reduce((sum, prod) => {
    let price = prod.partialPrice;
    if (typeof price === 'string') {
      price = price.replace(/[^\d.,-]/g, '').replace(',', '.');
    }
    return sum + parseFloat(price || 0);
  }, 0);
};

const calcolaPrezzoConIva = (prezzo, iva) => {
  const cleanPrezzo = parseFloat(String(prezzo).replace(/[^\d.,-]/g, '').replace(',', '.'));
  const ivaPercent = parseFloat(iva || '0');
  if (isNaN(cleanPrezzo) || isNaN(ivaPercent)) return 0;
  return (cleanPrezzo * (1 + ivaPercent / 100)).toFixed(2);
};

const prezzoSenzaIva = (prezzo) => {
  return parseFloat(String(prezzo).replace(/[^\d.,-]/g, '').replace(',', '.')) || 0;
};

const [orders, setOrders] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [drivers, setDrivers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [customerFilter, setCustomerFilter] = useState("");
  const [dateFilter, setDateFilter] = useState("");
  const [selectedProducts, setSelectedProducts] = useState([]); // array vuoto
  const [sedeFilter, setSedeFilter] = useState("");
  const [autistaFilter, setAutistaFilter] = useState("");
  const [statoFilter, setStatoFilter] = useState("");
  const [searchFilter, setSearchFilter] = useState("");
  const [tooltipData, setTooltipData] = useState({ value: '', visible: false, x: 0, y: 0 });
  const ordersPerPage = 20;
  const navigate = useNavigate();

  // ##### GR / RI: prodotti col prefisso scelto per la giornata selezionata
  const [grRiFilter, setGrRiFilter] = useState(null); // 'GR' oppure 'RI'
  const [grRiDate, setGrRiDate] = useState(new Date().toISOString().slice(0, 10));
  const [grRiSpuntati, setGrRiSpuntati] = useState([]); // codici spuntati (persistiti nel DB) per la data corrente

  // Ricava la data (YYYY-MM-DD) di un ordine: usa orderDate, altrimenti la data in coda all'orderId
  const getOrderDay = (ord) => {
    if (ord.orderDate) return String(ord.orderDate).slice(0, 10);
    const m = String(ord.orderId || "").match(/(\d{4}-\d{2}-\d{2})$/);
    return m ? m[1] : "";
  };

  const openGrRi = (prefix) => {
    setGrRiFilter(prefix);
  };

  // Carica dal DB i codici già spuntati per la data selezionata
  useEffect(() => {
    if (!grRiFilter || !grRiDate) return;
    let active = true;
    axios
      .get(`/api/grri-spuntati?date=${grRiDate}`)
      .then(({ data }) => { if (active) setGrRiSpuntati(Array.isArray(data) ? data : []); })
      .catch((err) => {
        console.error("Errore caricamento spuntati:", err);
        if (active) setGrRiSpuntati([]);
      });
    return () => { active = false; };
  }, [grRiFilter, grRiDate]);

  // Spunta / de-spunta un prodotto, salvando lo stato nel DB
  const toggleGrRiSpunta = async (code, checked) => {
    try {
      if (checked) {
        await axios.post("/api/grri-spuntati", { date: grRiDate, code });
        setGrRiSpuntati((prev) => Array.from(new Set([...prev, code])));
      } else {
        await axios.delete("/api/grri-spuntati", { data: { date: grRiDate, code } });
        setGrRiSpuntati((prev) => prev.filter((c) => c !== code));
      }
    } catch (err) {
      console.error("Errore aggiornamento spunta:", err);
      alert("Errore nel salvataggio dello stato spuntato.");
    }
  };

  // Aggrega i prodotti col prefisso scelto (GR o RI) degli ordini della data, sommando le quantità per codice
  const grRiProducts = React.useMemo(() => {
    if (!grRiDate || !grRiFilter) return [];
    const map = new Map();
    orders.forEach((ord) => {
      if (getOrderDay(ord) !== grRiDate) return;
      let prods = [];
      try {
        prods = ord.products
          ? (typeof ord.products === "string" ? JSON.parse(ord.products) : ord.products)
          : [];
      } catch {
        prods = [];
      }
      if (!Array.isArray(prods)) return;
      prods.forEach((p) => {
        const code = (p.code || "").trim().toUpperCase();
        if (!code.startsWith(grRiFilter)) return;
        const qty = parseFloat(String(p.quantity ?? "").replace(",", ".")) || 0;
        if (!map.has(code)) {
          map.set(code, {
            code,
            productName: (p.productName || "").trim(),
            unit: p.unit || "",
            quantity: 0,
            altValues: [],
          });
        }
        const entry = map.get(code);
        entry.quantity += qty;
        const altRaw = String(p.alternativeQuantity ?? "").trim();
        if (altRaw) entry.altValues.push(altRaw);
      });
    });
    return Array.from(map.values())
      .map((v) => {
        // Quantità alternativa: somma se tutti i valori sono numerici, altrimenti elenca i valori distinti
        let altQuantity = "";
        if (v.altValues.length) {
          const nums = v.altValues.map((a) => parseFloat(a.replace(",", ".")));
          const tuttiNumerici =
            v.altValues.every((a) => /^[\d.,\s]+$/.test(a)) &&
            nums.every((n) => Number.isFinite(n));
          altQuantity = tuttiNumerici
            ? String(Math.round(nums.reduce((s, n) => s + n, 0) * 1000) / 1000)
            : Array.from(new Set(v.altValues)).join(", ");
        }
        return {
          code: v.code,
          productName: v.productName,
          unit: v.unit,
          quantity: Math.round(v.quantity * 1000) / 1000,
          altQuantity,
        };
      })
      .sort((a, b) => a.code.localeCompare(b.code));
  }, [orders, grRiDate, grRiFilter]);

  // Prodotti ancora da prendere (non spuntati) -> usati per il PDF
  const grRiDaPrendere = grRiProducts.filter((p) => !grRiSpuntati.includes(p.code));

  // Export PDF della sola lista da prendere (esclude i prodotti già spuntati)
  const handleGrRiPDF = () => {
    if (!grRiDaPrendere.length) return;
    const doc = new jsPDF();
    doc.setFontSize(16);
    doc.text(`Prodotti ${grRiFilter} - ${grRiDate}`, 14, 20);
    const body = grRiDaPrendere.map((p) => [
      p.code,
      p.productName,
      String(p.quantity),
      p.unit,
      p.altQuantity,
    ]);
    doc.autoTable({
      startY: 30,
      head: [["Codice", "Prodotto", "Quantità", "UM", "Qt. alt."]],
      body,
    });
    doc.save(`${grRiFilter}_${grRiDate}.pdf`);
  };


const TdWithTooltip = ({ children, tooltip }) => {
  const [show, setShow] = useState(false);

  return (
    <TdStyled
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
    >
      <span className="truncate block">{children}</span>
      {show && (
        <div className="tooltip-custom">
          {tooltip}
        </div>
      )}
    </TdStyled>
  );
};

const handleCellClick = (event, value) => {
  const rect = event.currentTarget.getBoundingClientRect();
  setTooltipData({
    value,
    visible: true,
    x: rect.left + window.scrollX,
    y: rect.bottom + window.scrollY,
  });
};


  // Carica gli ordini
  const location = useLocation();
  useEffect(() => {
    axios
      .get("/api/orders")
      .then((response) => {
        if (Array.isArray(response.data)) {
          setOrders(response.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching orders:", error);
      });
  }, [location]);

const [selectedOrderId, setSelectedOrderId] = useState("");
const openProductsModal = (orderId) => {
  setSelectedOrderId(orderId);
  axios
    .get(`/api/orders/${encodeURIComponent(orderId)}/products`)
    .then((response) => {
      if (Array.isArray(response.data)) {
        setSelectedProducts(response.data);
      } else {
        setSelectedProducts([]);
      }
      setModalOpen(true);
    })
    .catch((error) => {
      console.error("Errore nel recuperare prodotti:", error);
      setSelectedProducts([]);
      setModalOpen(true);
    });
};


  const closeModal = () => {
    setModalOpen(false);
    setSelectedProducts([]);
  };

  // Carica gli autisti
  useEffect(() => {
    axios
      .get("/api/autisti")  // cambia con il tuo endpoint giusto
      .then((response) => {
        if (Array.isArray(response.data)) {
          setDrivers(response.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching drivers:", error);
      });
  }, []);

  // Trova colore autista dato nome
  const getDriverColor = (driverName) => {
    const driver = drivers.find((d) => d.nome === driverName);
    return driver ? driver.colore : '#ccc';
  };

  // Filtri, paginazione, etc...
const filteredOrders = orders.filter((ord) => {
  const orderId = ord.orderId.toLowerCase();
  const autista = ord.autista?.toLowerCase() || "";
  const stato = ord.status?.toLowerCase() || "";

  const searchMatch = searchFilter
    ? orderId.includes(searchFilter.toLowerCase())
    : true;

  const autistaMatch = autistaFilter
    ? autista.includes(autistaFilter.toLowerCase())
    : true;

  const statoMatch = statoFilter
    ? stato.includes(statoFilter.toLowerCase())
    : true;

  return searchMatch && autistaMatch && statoMatch;
});

  const indexOfLastOrder = currentPage * ordersPerPage;
  const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
  const currentOrders = filteredOrders.slice(indexOfFirstOrder, indexOfLastOrder);
  const totalPages = Math.ceil(filteredOrders.length / ordersPerPage);

  const handleCreateNewOrder = () => {
    function generateOrderId() {
      const now = new Date();
      const dd = String(now.getDate()).padStart(2, "0");
      const mm = String(now.getMonth() + 1).padStart(2, "0");
      const yy = String(now.getFullYear()).slice(-2);
      const hh = String(now.getHours()).padStart(2, "0");
      const min = String(now.getMinutes()).padStart(2, "0");

      return `ORD_${dd}-${mm}-${yy}-${hh}-${min}`;
    }

    const newOrderId = generateOrderId();
    navigate(`/add-product/${newOrderId}`);
  };

  const handleManageOrders = () => {
    navigate("/ordersedit");
  };



{tooltipData.visible && (
  <div
    id="order-tooltip"
    style={{
      position: 'absolute',
      top: tooltipData.y,
      left: tooltipData.x,
      background: '#333',
      color: '#fff',
      padding: '6px 10px',
      borderRadius: '6px',
      zIndex: 9999,
      maxWidth: '300px',
      pointerEvents: 'auto',
      userSelect: 'none',
    }}
    onClick={() => setTooltipData({ ...tooltipData, visible: false })}
  >
    {tooltipData.value}
  </div>
)}



useEffect(() => {
  function handleClickOutside(event) {
    // Se tooltip non è visibile, non fare nulla
    if (!tooltipData.visible) return;

    // Trova l'elemento tooltip nel DOM (usando un id o ref)
    const tooltipElement = document.getElementById('order-tooltip');

    // Se non esiste tooltip o il click è fuori tooltip
    // e non è sulla cella dell'ordine (che ha classe o id specifico)
    if (
      tooltipElement &&
      !tooltipElement.contains(event.target) &&
      !event.target.classList.contains('order-cell')
    ) {
      setTooltipData({ ...tooltipData, visible: false });
    }
  }

  document.addEventListener('click', handleClickOutside);

  return () => {
    document.removeEventListener('click', handleClickOutside);
  };
}, [tooltipData]);



// DOWNLOAD PDF
const handleDownloadPDF = () => {
  if (!selectedProducts.length) return;
  const doc = new jsPDF();
  const orderId = selectedProducts[0]?.orderId || 'ordine';
  const first = selectedProducts[0];
  doc.setFontSize(16);
  doc.text(`Preventivo ${selectedOrderId}`, 14, 20);
  doc.setFontSize(12);

const tableData = selectedProducts.map((prod, idx) => {
  const netto = prezzoSenzaIva(prod.selectedSalePrice);
  const parzialeNetto = netto * parseFloat(prod.quantity || 0);
  return [
    idx + 1,
    prod.productName,
    prod.lotto || '',
    prod.quantity,
    prod.unit,
    `${netto.toFixed(2)} €`,
    `${parzialeNetto.toFixed(2)} €`,
  ];
});

const total = selectedProducts.reduce((acc, prod) => {
  const netto = prezzoSenzaIva(prod.selectedSalePrice);
  const ivaPercent = parseFloat(prod.iva || '0');
  const nettoTotale = netto * parseFloat(prod.quantity || 0);
  const ivato = nettoTotale * (1 + ivaPercent / 100);
  return acc + ivato;
}, 0);  


tableData.push([
    '', // Vuoto per la colonna numero
    'Totale (IVA Incl. )',
    '',
    '',
    total.toFixed(2) + ' €',
  ]);

  doc.autoTable({
    startY: 30,
    head: [['#', 'Prodotto', 'Lotto', 'Quantità', 'UM', 'Prezzo unitario', 'Prezzo parziale']],
    body: tableData,
  });

  doc.save(`preventivo_${selectedOrderId}.pdf`);
};

function estraiClienteDaOrderId(orderId) {
  const lastDash = orderId.lastIndexOf("-");
  if (lastDash === -1) return orderId.trim();
  return orderId.substring(0, lastDash).trim();
}


// ##### Download ordini del giorno
const handleDownloadODG = () => {
  const today = new Date().toISOString().slice(0, 10);

  const odgOrders = orders.filter((ord) =>
    ord.orderDate?.slice(0, 10) === today
  );

  if (!odgOrders.length) {
    alert("Nessun ordine per oggi.");
    return;
  }

  const doc = new jsPDF();
  doc.setFontSize(16);
  doc.text("Ordini del Giorno", 14, 20);

  const tableData = odgOrders.map((ord) => {
function estraiClienteDaOrderId(orderId = "") {
  const idx = orderId.lastIndexOf(" - ");
  if (idx === -1) {
    return orderId.trim(); // nessun " - ", ritorniamo tutto
  }
  return orderId.substring(0, idx).trim();
}
  const customer = estraiClienteDaOrderId(ord.orderId);

    return [
      customer,
      ord.sede || "-"
    ];
  });

  doc.autoTable({
    startY: 30,
    head: [["Cliente", "Sede"]],
    body: tableData,
  });

  doc.save(`ODG_${today}.pdf`);
};
// ########################################################################

// Calcolo Marginalità % totale (senza IVA)
const marginalitaData = selectedProducts.reduce(
  (acc, prod) => {
    const prezzoVendita = parseFloat(String(prod.selectedSalePrice).replace(/[^\d.,-]/g, '').replace(',', '.')) || 0;
    const prezzoAcquisto = parseFloat(String(prod.purchasePrice).replace(/[^\d.,-]/g, '').replace(',', '.')) || 0;
    const qty = parseFloat(prod.quantity || 0);

    acc.totVendita += prezzoVendita * qty;
    acc.totAcquisto += prezzoAcquisto * qty;
    return acc;
  },
  { totVendita: 0, totAcquisto: 0 }
);

// Calcolo marginalità come mark-up sul costo di acquisto
const marginalitaPerc =
  marginalitaData.totAcquisto > 0
    ? ((marginalitaData.totVendita - marginalitaData.totAcquisto) / marginalitaData.totAcquisto) * 100
    : 0;
//#################################################


  return (
    <>
      <GlobalStyle />
      <PageContainer>
      <Content>
        <TopButtons>
          <Button onClick={handleCreateNewOrder}>Crea Nuovo Ordine</Button>
          <Button onClick={handleManageOrders}>Gestisci Ordini</Button>
	  <Button onClick={() => openGrRi("GR")} style={{ padding: "6px 12px", fontSize: "0.85rem" }}>GR</Button>
	  <Button onClick={() => openGrRi("RI")} style={{ padding: "6px 12px", fontSize: "0.85rem" }}>RI</Button>
	  <Button onClick={handleDownloadODG}>ODG</Button>
        </TopButtons>

<FiltersContainer>
  <Input
    type="text"
    placeholder="Filtra cliente / Data di consegna"
    value={searchFilter}
    onChange={(e) => {
      setSearchFilter(e.target.value);
      setCurrentPage(1);
    }}
   />

  <Input
    type="text"
    placeholder="Filtra per stato"
    value={statoFilter}
    onChange={(e) => {
      setStatoFilter(e.target.value);
      setCurrentPage(1);
    }}
  />

  <Input
    type="text"
    placeholder="Filtra per autista"
    value={autistaFilter}
    onChange={(e) => {
      setAutistaFilter(e.target.value);
      setCurrentPage(1);
    }}
  />
</FiltersContainer>


        <TableWrapper>
        <Table>
          <thead>
            <tr>
              <Th>Ordine</Th>
              <Th>Sede</Th>
	      <Th>Stato</Th>
              <Th>Autista</Th>
	      <Th>Prodotti</Th>
            </tr>
          </thead>
          <tbody>
            {currentOrders.length > 0 ? (
              currentOrders.map((ord) => (
                <tr key={ord.orderId}>


<Td
  className="order-cell"
  style={{
    maxWidth: '150px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    border: '1px solid #ccc',
    cursor: 'pointer',
  }}
  onClick={(e) => handleCellClick(e, ord.orderId)}
>
  {ord.orderId}
</Td>

                  <Td>{ord.sede}</Td>
		  <Td>{ord.status || "-"}</Td>
                  <Td>
                    <DriverColorDot color={getDriverColor(ord.autista)} />
                    {ord.autista || "-"}
                  </Td>
		               <Td>
		  <Button onClick={() => openProductsModal(ord.orderId)} title="Visualizza prodotti">
                   {window.innerWidth <= 768 ? <FaEye /> : "Visualizza prodotti"}
                </Button>
              </Td>
                </tr>
              ))
            ) : (
              <tr>
                <Td colSpan="3">Nessun ordine trovato.</Td>
              </tr>
            )}
          </tbody>
        </Table>

         {tooltipData.visible && (
            <div
              style={{
                position: 'absolute',
                top: tooltipData.y,
                left: tooltipData.x,
                background: '#333',
                color: '#fff',
                padding: '6px 10px',
                borderRadius: '6px',
                zIndex: 9999,
                maxWidth: '300px',
                pointerEvents: 'auto', // per permettere il click su tooltip
                userSelect: 'none',
              }}
              onClick={() => setTooltipData({ ...tooltipData, visible: false })}
            >
              {tooltipData.value}
            </div>
          )}

	</TableWrapper>

      {modalOpen && (
        <ModalOverlay onClick={closeModal}>
<ModalContent onClick={(e) => e.stopPropagation()}>
  <h4>Preventivo {selectedOrderId} </h4>
  {selectedProducts.length > 0 ? (
    <table style={{ width: "100%", borderCollapse: "collapse" }}>
      <thead>
        <tr>
          <th style={{ borderBottom: "1px solid #ddd", padding: "8px", textAlign: "left" }}>Prodotto</th>
          <th style={{ borderBottom: "1px solid #ddd", padding: "8px", textAlign: "right" }}>Quantità</th>
	  <th style={{ borderBottom: "1px solid #ddd", padding: "8px", textAlign: "right" }}>UM</th>
          <th style={{ borderBottom: "1px solid #ddd", padding: "8px", textAlign: "right" }}>Prezzo unitario</th>
          <th style={{ borderBottom: "1px solid #ddd", padding: "8px", textAlign: "right" }}>Prezzo parziale</th>
        </tr>
      </thead>
      <tbody>
        {selectedProducts.map((prod, index) => (
          <tr key={index}>
            <td style={{ borderBottom: "1px solid #eee", padding: "8px" }}>{prod.productName.trim()}</td>
            <td style={{ borderBottom: "1px solid #eee", padding: "8px", textAlign: "right" }}>{prod.quantity}</td>
	    <td style={{ borderBottom: "1px solid #eee", padding: "8px", textAlign: "right" }}>{prod.unit}</td>

<td style={{ borderBottom: "1px solid #eee", padding: "8px", textAlign: "right" }}>
  {prezzoSenzaIva(prod.selectedSalePrice).toFixed(2)} €
</td>
<td style={{ borderBottom: "1px solid #eee", padding: "8px", textAlign: "right" }}>
  {(prezzoSenzaIva(prod.selectedSalePrice) * parseFloat(prod.quantity || 0)).toFixed(2)} €
</td>

          </tr>
        ))}
      </tbody>
    </table>
  ) : (
    <p>Nessun prodotto disponibile.</p>
  )}

<p
  style={{
    fontWeight: 'bold',
    textAlign: 'right',
    marginTop: '10px',
    color: marginalitaPerc >= 0 ? '#28a745' : '#dc3545'
  }}
>
  Marginalità: {marginalitaPerc.toFixed(2)}%
</p>
<p style={{ fontWeight: 'bold', textAlign: 'right', marginTop: '10px' }}>
  Totale: {selectedProducts.reduce((acc, prod) => {
    const netto = prezzoSenzaIva(prod.selectedSalePrice);
    const ivaPercent = parseFloat(prod.iva || '0');
    const nettoTotale = netto * parseFloat(prod.quantity || 0);
    const ivato = nettoTotale * (1 + ivaPercent / 100);
    return acc + ivato;
  }, 0).toFixed(2)} €
</p>

  <TopButtons>
  <Button onClick={handleDownloadPDF}>Scarica PDF</Button>
  <Button onClick={closeModal}>Chiudi</Button>
  </TopButtons>
</ModalContent>
        </ModalOverlay>
      )}

      {grRiFilter && (
        <ModalOverlay onClick={() => setGrRiFilter(null)}>
          <ModalContent onClick={(e) => e.stopPropagation()}>
            <h4>Prodotti {grRiFilter} per giornata</h4>
            <div style={{ marginBottom: "12px", display: "flex", alignItems: "center", gap: "8px" }}>
              <label>Data:</label>
              <input
                type="date"
                value={grRiDate}
                onChange={(e) => setGrRiDate(e.target.value)}
                style={{ padding: "6px", border: "1px solid #ccc", borderRadius: "4px" }}
              />
            </div>
            {grRiProducts.length > 0 ? (
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    <th style={{ borderBottom: "1px solid #ddd", padding: "8px", textAlign: "center", width: "40px" }}>✓</th>
                    <th style={{ borderBottom: "1px solid #ddd", padding: "8px", textAlign: "left" }}>Codice</th>
                    <th style={{ borderBottom: "1px solid #ddd", padding: "8px", textAlign: "left" }}>Prodotto</th>
                    <th style={{ borderBottom: "1px solid #ddd", padding: "8px", textAlign: "right" }}>Quantità</th>
                    <th style={{ borderBottom: "1px solid #ddd", padding: "8px", textAlign: "left" }}>UM</th>
                  </tr>
                </thead>
                <tbody>
                  {grRiProducts.map((p) => {
                    const spuntato = grRiSpuntati.includes(p.code);
                    return (
                      <tr
                        key={p.code}
                        style={{
                          opacity: spuntato ? 0.5 : 1,
                          textDecoration: spuntato ? "line-through" : "none",
                        }}
                      >
                        <td style={{ borderBottom: "1px solid #eee", padding: "8px", textAlign: "center" }}>
                          <input
                            type="checkbox"
                            checked={spuntato}
                            onChange={(e) => toggleGrRiSpunta(p.code, e.target.checked)}
                            title="Segna come preso"
                          />
                        </td>
                        <td style={{ borderBottom: "1px solid #eee", padding: "8px" }}>{p.code}</td>
                        <td style={{ borderBottom: "1px solid #eee", padding: "8px" }}>{p.productName}</td>
                        <td style={{ borderBottom: "1px solid #eee", padding: "8px", textAlign: "right" }}>{p.quantity}</td>
                        <td style={{ borderBottom: "1px solid #eee", padding: "8px" }}>{p.unit}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            ) : (
              <p>Nessun prodotto {grRiFilter} per la data selezionata.</p>
            )}
            <TopButtons style={{ marginTop: "16px" }}>
              <Button onClick={handleGrRiPDF} disabled={!grRiDaPrendere.length}>PDF</Button>
              <Button onClick={() => setGrRiFilter(null)}>Salva e chiudi</Button>
            </TopButtons>
          </ModalContent>
        </ModalOverlay>
      )}

        {totalPages > 1 && (
          <Pagination>
            <Button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
            >
              ← Precedente
            </Button>
            <span>Pagina {currentPage} di {totalPages}</span>
            <Button
              onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
              disabled={currentPage === totalPages}
            >
              Successiva →
            </Button>
          </Pagination>
        )}
       </Content>
      </PageContainer>
    </>
  );
};

export default CreateOrder;
